<formatted-value *ngIf="currentValue !== null; else noDataTemplate" [value]="currentValue" [formatting]="formatting" [maximumFractionDigits]="5" maxFormattingUnitWidth="100px"></formatted-value>
<ng-template #noDataTemplate>
  <div class="no-data">{{ "no_data_available" | localize }}</div>
</ng-template>

<progress-indicator-label
  *ngIf="progressIndicatorData"
  [isAccent]="true"
  [deltaPercentage]="progressIndicatorData.deltaPercentage"
  [lessIsBetter]="progressIndicatorData.lessIsBetter"></progress-indicator-label>
